<template>
  <transition name="cookie-slide">
    <div
      v-if="visible"
      class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-indigo-500 shadow-xl"
    >
      <div class="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <!-- Text -->
        <p class="flex-1 text-sm text-gray-700">
          {{ $t('cookie_message') }}
          <router-link to="/gdpr" class="text-indigo-600 underline hover:text-indigo-800 font-medium ml-1">
            {{ $t('cookie_learn_more') }}
          </router-link>
        </p>

        <!-- Buttons -->
        <div class="flex gap-3 shrink-0">
          <button
            @click="accept"
            class="px-5 py-2 text-sm rounded-full bg-indigo-500 hover:bg-indigo-600 text-white font-semibold transition-colors duration-200"
          >
            {{ $t('cookie_accept') }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const STORAGE_KEY = 'cookie_consent';

export default {
  name: 'CookieConsent',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Consent is implied by continuing to use the site — grant immediately
      this.grantConsent();
      if (typeof window.clarity === 'function') {
        window.clarity('consent');
      }
      this.visible = true;
    } else if (saved === 'accepted') {
      this.grantConsent();
    }
  },
  methods: {
    accept() {
      // Just dismiss the banner and remember the choice
      localStorage.setItem(STORAGE_KEY, 'accepted');
      this.visible = false;
    },
    grantConsent() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'consent_update',
        analytics_storage: 'granted',
        ad_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
      });
    },
  },
};
</script>

<style scoped>
.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
